import { Country, InputDataProps } from '../types'
import { IGlobalState } from '../types'

interface IGetData extends IGlobalState {
  data: any
}

export default function getDataAIMetricOT({
  countryType = 'global',
  country = 'USA',
  metric = {
    rad: {
      absolute: 'number_of_total_journal_publications',
      perCapita: 'pc_number_of_total_journal_publications',
    },
    eco: {
      absolute: 'private_investment',
      perCapita: 'pc_private_investment',
    },
    edu: {
      absolute: 'number_of_ai_study_programs_in_english',
      perCapita: 'pc_number_of_ai_study_programs_in_english',
    },
    div: {
      absolute: 'ai_talent_concentration_gender_equality_index',
      perCapita: '',
    },
    pol: {
      // absolute: 'national_ai_strategy_is_released',
      // perCapita: 'pc_national_ai_strategy_is_released',
      absolute: 'num_ai_related_bills_passed',
      perCapita: 'pc_num_ai_related_bills_passed',
    },
    pub: {
      absolute: 'social_media_share_of_voice_on_ai',
      perCapita: 'pc_social_media_share_of_voice_on_ai',
    },
    inf: {
      perCapita: 'pc_parts_semiconductor_devices_export_value',
      absolute: 'parts_semiconductor_devices_export_value',
    },
    rai: {
      perCapita: 'pc_number_of_ra_submissions_aaai',
      absolute: 'number_of_ra_submissions_aaai',
    },
  },
  metricType = 'rad',
  metricValue = 'absolute',
  data,
}: IGetData): InputDataProps[] {
  // 23 Apr 2024, disable Global in CountryDropdown
  // if (countryType === 'global') {
  //   const globalAIMOT = getMetricData(data, metric[metricType][metricValue])
  //   return globalAIMOT
  // } else {
  const nationalAIMOT = getMetricData(data, metric[metricType][metricValue], country)
  return nationalAIMOT
  // }
}

export function getMetricData(data: any, currentMetric: string, country?: string) {
  if (country) {
    const filteredData = data
      ?.filter((item: any) => item[currentMetric] !== undefined && item['Code'] === country)
      .map((item: any) => ({
        year: item['PublishYear'],
        value: parseFloat(item[currentMetric]) || 0,
      }))

    return filteredData
  } else {
    const aggregatedData = data?.reduce((total: any, current: any) => {
      const year = current.PublishYear
      const value = parseFloat(current[currentMetric]) || 0

      if (!total[year]) {
        total[year] = value
      } else {
        total[year] += value
      }
      return total
    }, {})
    if (aggregatedData) {
      const outputArray: InputDataProps[] = Object.entries(aggregatedData)?.map(([year, value]) => ({
        year,
        value,
      }))
      return outputArray
    }
  }
  return []
}

export function getFirstAndLastYear(data: any[] | undefined) {
  if (data === undefined) {
    return null
  } else {
    if (!Array.isArray(data) || data.length === 0) {
      return null // Handle invalid input
    }

    let firstYearWithNonZeroValue: string | undefined
    let lastYearWithNonZeroValue: string | undefined

    for (const item of data) {
      if (item.value !== 0) {
        if (!firstYearWithNonZeroValue) {
          firstYearWithNonZeroValue = item.year
        }
        lastYearWithNonZeroValue = item.year
      }
    }

    return {
      firstYear: firstYearWithNonZeroValue,
      lastYear: lastYearWithNonZeroValue,
    }
  }
}

export function getCountryDataByYearAndMetric(data: Country[], publishYear: number, metricCode: string) {
  return data?.map((countryData) => {
    const metricData = countryData?.metadatas?.find((entry) => entry.PublishYear === publishYear)

    if (metricData && metricData.hasOwnProperty(metricCode)) {
      return {
        country: countryData?.countryCode,
        countryLongCode: countryData?.countryLongCode,
        value: metricData[metricCode],
      }
    } else {
      return {
        country: countryData?.countryCode,
        countryLongCode: countryData?.countryLongCode,
        value: 0,
      }
    }
  })
}

export function getYearSliderLimits(data: Country[], metricCode: string, yrArr: number[]) {
  let filteredData = yrArr.map(i => {
    return {
      year: i, data: data?.map((countryData) => {
        const metricData = countryData?.metadatas?.find((entry) => entry.PublishYear === i)
        if (metricData && metricData[metricCode]) {
          return { country: countryData.countryName, metricValue: metricData[metricCode] }
        } else {
          return { country: countryData.countryName, metricValue: NaN }
        }
      })
    }
  });

  let filteredYears: number[] = []

  filteredData.forEach((yrData) => {
    if (!yrData.data.every(i => Number.isNaN(i.metricValue))) {
      filteredYears.push(yrData.year)
    }
  })
  return {
    minYear: Math.min(...filteredYears),
    maxYear: Math.max(...filteredYears)
  }
}